const state = {
    newVersion: null,
    blogVersion: null,
};


const getters = {

	getNewUpdateVersion(state) {
		return state.newVersion
	},
	getBlogUpdateVersion(state) {
		return state.blogVersion
	}

};

const actions = {

    setNewVersion({ commit, getters }, payload) {
        commit('SET_NEW_VERSION', { getters, payload });
    },

};

const mutations = {

    'SET_NEW_VERSION'(state, { getters, payload }) {

		// If there is a latest_update date in the backend
		if(payload.data.latest_update)
		{
			if(state.newVersion != payload.data.latest_update)
			{
				console.log('payload.data.latest_update', payload.data.latest_update)
				// Set a new value to the frontend newVersion
				state.newVersion = payload.data.latest_update
			}
		}

		// If there is a blog_update date in the backend
		if(payload.data.blog_update)
		{
			if(state.blogVersion != payload.data.blog_update)
			{
				console.log('payload.data.blog_update', payload.data.blog_update)
				// Set a new value to the blogVersion
				state.blogVersion = payload.data.blog_update
			}
		}
		else
		{
			state.blogVersion = null
		}

		return true
    },

};

export default {
    mutations,
    actions,
    getters,
    state: state
};
